import React from 'react';
import ContentLoader from 'react-content-loader';

const FormLoader: React.FC = () => (
  <ContentLoader
    speed={2}
    width={400}
    height={160}
    viewBox="0 0 400 160"
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
  >
    {/* You can adjust these SVG rectangles to match the layout of your form */}
    <rect x="10" y="20" rx="4" ry="4" width="300" height="13" />
    <rect x="10" y="50" rx="4" ry="4" width="250" height="13" />
    <rect x="10" y="80" rx="4" ry="4" width="180" height="13" />
    <rect x="10" y="110" rx="4" ry="4" width="150" height="13" />
    <rect x="10" y="140" rx="4" ry="4" width="120" height="13" />
  </ContentLoader>
);

export default FormLoader;
